import { render } from "./CameraTab.vue?vue&type=template&id=2663bbb6&scoped=true&ts=true"
import script from "./CameraTab.vue?vue&type=script&lang=ts"
export * from "./CameraTab.vue?vue&type=script&lang=ts"

import "./CameraTab.vue?vue&type=style&index=0&id=2663bbb6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2663bbb6"]])

export default __exports__